var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#105B2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76856 10.2263L6.54919 11.344L6.14981 13.3977C6.13856 13.4596 6.12281 13.5012 6.04406 13.5001C5.54794 13.4928 5.05181 13.4888 4.55569 13.4832C4.54387 13.4832 4.5315 13.4753 4.5 13.4635L5.61937 7.87227H4.67606C4.67831 7.83065 4.67719 7.8059 4.68169 7.78227C4.73962 7.48021 4.80206 7.17871 4.85438 6.87552C4.869 6.79114 4.90669 6.76977 4.98544 6.77033C5.21606 6.77258 5.44669 6.76414 5.67619 6.77202C5.78587 6.77539 5.82806 6.7439 5.84944 6.6359C5.97769 5.96765 6.11494 5.30165 6.24656 4.63452C6.26231 4.55521 6.27975 4.50065 6.38325 4.50065C7.51275 4.50402 8.64281 4.49333 9.77231 4.50796C10.4316 4.5164 11.0925 4.55015 11.7411 4.68346C11.9644 4.72958 12.1911 4.78921 12.3981 4.88146C12.9932 5.14583 13.3515 5.60371 13.4511 6.23764C13.6058 7.22258 13.3971 8.12765 12.7648 8.91627C12.2979 9.49677 11.6578 9.82246 10.9429 10.0205C10.3759 10.1774 9.79425 10.2263 9.20813 10.2275C8.44594 10.2291 7.68375 10.2275 6.92156 10.2269L6.76856 10.2263ZM7.08075 8.68621H7.23994C8.046 8.68621 8.85206 8.68789 9.65869 8.68508C9.83025 8.68508 10.0041 8.67777 10.1745 8.65696C10.8253 8.57933 11.3198 8.26714 11.6359 7.70071C11.7715 7.45506 11.8171 7.16975 11.7647 6.89408C11.6983 6.50202 11.4643 6.24608 11.0666 6.17408C10.7755 6.1186 10.4803 6.08662 10.1841 6.07846C9.35606 6.06327 8.52806 6.06946 7.6995 6.06721C7.66969 6.06721 7.63987 6.07171 7.59994 6.07508L7.46269 6.77708H9.76331L9.55181 7.86721H7.24388L7.08075 8.68621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot);
export default __webpack_public_path__ + "static/media/pot.433b3ae766ad886f8aefa22044c25bfa.svg";
export { ForwardRef as ReactComponent };